export enum YesOrNo {
	Yes = 'yes',
	No = 'no',
}
